import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from '../../util/reactIntl';
import { HiLightBulb } from 'react-icons/hi';
import { IoMdClose } from 'react-icons/io';
import NamedLink from '../NamedLink/NamedLink';

import css from './VatStatusBanner.css';

// Soft reminder for providers (spec §5): a migrated VAT status wants a
// confirmation; an exempt status wants a yearly reconfirmation. Never blocks.
const VatStatusBanner = ({ reason, onClose }) => {
  if (!reason) return null;
  return (
    <div className={css.banner} role="status">
      <button type="button" className={css.closeButton} onClick={onClose} aria-label="Close">
        <IoMdClose className={css.closeIcon} />
      </button>
      <div className={css.bannerContent}>
        <HiLightBulb className={css.icon} />
        <p className={css.message}>
          <FormattedMessage id={`VatStatusBanner.${reason}`} />
        </p>
        <NamedLink name="TaxInformationPage" className={css.link}>
          <FormattedMessage id="VatStatusBanner.cta" />
        </NamedLink>
      </div>
    </div>
  );
};

VatStatusBanner.defaultProps = { reason: null };
VatStatusBanner.propTypes = { reason: PropTypes.string, onClose: PropTypes.func.isRequired };

export default VatStatusBanner;
